import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import { SelectCustom } from '../../../../../common/selectCustom'
import { selectCurrency } from '../../../../../userManagement/settingPreferences/store/slice'
import { Z_INDEX } from '../../../../../utils/common'
import { CURRENCY, CURRENCY_UNIT, UNIT } from '../../../../../utils/currency'
import { copyObj } from '../helper'
import classes from '../index.module.scss'
import { selectCurrencyUnitFs } from '../store/slice'
import GroupButton from './GroupButton'

const CurrencyUnit = ({ isShow, handleClose }) => {
  const currencyUnitFs = useSelector(selectCurrencyUnitFs)
  const defaultCurrency = useSelector(selectCurrency)

  const [currencyUnit, setCurrencyUnit] = useState([])

  useEffect(() => {
    if (isShow) {
      setCurrencyUnit(currencyUnitFs)
    }
  }, [isShow])

  const chooseItem =
    (index, key, unit) =>
    ({ value }) => {
      const newCurrencyUnit = copyObj(currencyUnit)
      newCurrencyUnit[index][key] = value
      if (key === 'currency' && !CURRENCY_UNIT[value].includes(unit)) {
        newCurrencyUnit[index].unit = UNIT.SINGLE.unitKey
      }
      setCurrencyUnit(newCurrencyUnit)
    }

  const addItem = () => {
    const newCurrencyUnit = copyObj(currencyUnit)
    newCurrencyUnit.push({
      currency: defaultCurrency,
      unit: UNIT.SINGLE.unitKey,
    })
    setCurrencyUnit(newCurrencyUnit)
  }

  const removeItem = (index) => () => {
    const newCurrencyUnit = copyObj(currencyUnit)
    newCurrencyUnit.splice(index, 1)
    setCurrencyUnit(newCurrencyUnit)
  }

  return (
    <>
      <Element
        className={classes.currencyUnitSettingFs}
        style={{ backgroundColor: '#FFFFFF' }}
      >
        {currencyUnit.map(({ currency, unit }, index) => {
          const isLastItem = index === currencyUnit.length - 1
          const isFirstItem = !index

          return (
            <div
              key={index}
              className={`${!isFirstItem ? classes.mt12 : ''} dFlex ${
                classes.w850
              }`}
            >
              <div className="w40 dFlex alignItemsCenter justifyContentBetween">
                <Translate
                  className={`fw600 ${classes.maxWidth190}`}
                  value={
                    !index
                      ? 'dynamicReport.CURRENCY'
                      : 'dynamicReport.ADDITIONAL_FS'
                  }
                />
                <div className={classes.selectCurrencyUnit2}>
                  <SelectCustom
                    activeItem={{ value: currency }}
                    data={Object.values(CURRENCY).map((item) => ({
                      label: item,
                      value: item,
                    }))}
                    chooseItem={chooseItem(index, 'currency', unit)}
                    zIndex={Z_INDEX.MODAL + 1}
                  />
                </div>
              </div>
              <div
                className={`w30 pl6 dFlex alignItemsCenter ${classes.unitContainer}`}
              >
                <Translate className="fw600" value="dynamicReport.UNIT" />
                <div className={classes.selectCurrencyUnit2}>
                  <SelectCustom
                    activeItem={{ value: unit }}
                    data={CURRENCY_UNIT[currency].map((unitKey) => ({
                      label: UNIT[unitKey].label,
                      value: unitKey,
                      isI18n: true,
                    }))}
                    isI18n
                    chooseItem={chooseItem(index, 'unit')}
                    zIndex={Z_INDEX.MODAL + 1}
                  />
                </div>
              </div>
              <div className="w10 dFlex alignItemsCenter justifyContentEnd">
                {!!index && (
                  <Icon
                    style={{ color: '#9C9C9C', fontSize: 17 }}
                    className="icon-delete-circle-fill"
                    onClick={removeItem(index)}
                  />
                )}
                {isLastItem && (
                  <Icon
                    style={{ color: '#2C73E8', fontSize: 17 }}
                    className="icon-plus-circle-fill pl1"
                    onClick={addItem}
                  />
                )}
              </div>
            </div>
          )
        })}
      </Element>
      <GroupButton handleClose={handleClose} currencyUnit={currencyUnit} />
    </>
  )
}

export default CurrencyUnit
